import { Grid, Typography } from '@mui/material';
import MFSelectField from '../../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../../investors/components';
import { MFTextField } from '../../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { Applicant } from '../../../redux-store/types/api-types';
import {
  grossAnnualMasters,
  investorTypeMasters,
  ONBOARDING_ID_TYPES_MASTER,
  PEPsMasters,
  SAVE_LATER_VALIDATION_CHECK,
} from '../../../utils/constant';
import { DatePicker } from '../../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  checkRelationshipWithPep,
  currencyConversion,
  folioValidationCheck,
  getRelationshipWithPepLabel,
  isIdTypeOutOfList,
  removeSingleQuote,
  saveForLater,
  getStep,
  IsInvestorWithPAN,
  ifPushToXalt,
} from '../../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { updateApplication } from '../../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../../utils/schema';
import { useSnackbar } from 'notistack';
import FieldValidationNote from '../../investors/FieldValidationNote';
import MFCheckbox from '../../../lib/formik/Checkbox';

const contributorObject: Partial<Applicant> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '',
  netWorth: '',
  taxIdNumber: '',
  corporateIdentificationNo: '',
  politicallyExposedPersonStatus: '',
  relationshipWithPep: '',
  panDeclaration: false,
  pan: '',
  boiOrAop: '',
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicationSource: string;
  folio_no: string | null;
  applicants: Partial<Applicant>[];
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  applicationSource: 'digitalonboarding',
  folio_no: '',
  saveType: 'save and proceed',
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { flowType = '' } = application || {};
  useEffect(() => {
    try {
      const {
        applicants = [],
        applicationSource = 'digitalonboarding',
        folio_no = '',
      } = application || {};
      setContributorValues({
        ...contributorValues,
        folio_no: folio_no,
        applicationSource: applicationSource || 'digitalonboarding',
        applicants: applicants.length
          ? applicants.map((applicant) => ({
              ...applicant,
              panDeclaration: applicant.panDeclaration ? applicant.panDeclaration : false,
              boiOrAop: applicant.boiOrAop || '',
            }))
          : [contributorObject],
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType, applicants = [], folio_no, applicationSource } = values;
    const {
      id,
      currentStep,
      banks = [],
      applicant1ReferenceId = '',
      applicationNumber,
    } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        folio_no: folioValidationCheck(applicationSource) ? folio_no : '',
        applicationSource,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
            relationshipWithPep: checkRelationshipWithPep(
              applicant.politicallyExposedPersonStatus || ''
            )
              ? applicant.relationshipWithPep
              : null,
            pan: applicant.panDeclaration ? null : applicant.pan,
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );

    const isSaveLater = saveType !== 'save and proceed';
    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              relationshipWithPep: checkRelationshipWithPep(
                applicant.politicallyExposedPersonStatus || ''
              )
                ? applicant.relationshipWithPep
                : null,
              pan: applicant.panDeclaration ? null : applicant.pan,
              boiOrAop:
                ifPushToXalt(application?.pushDataTo || '') &&
                investorTypeMasters[applicant?.investorType || ''] ===
                  investorTypeMasters.boi_or_aop
                  ? applicant.boiOrAop
                  : '',
            })),
            modeOfHolding: 'single',
            folio_no: folioValidationCheck(applicationSource) ? folio_no : '',
            applicationSource,
            currentStep: getStep(2, isSaveLater),
            ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
          flowType,
        })
      );
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } else if (checkApplication) {
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      await handleApplicant(values);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(ifPushToXalt(application?.pushDataTo || '')),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {/* <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }} mb={2}>
              <UseRadioGroup
                formLabel="Application Source"
                name="applicationSource"
                defaultValue="digitalonboarding"
                items={Object.keys(ApplicationSourceMaster).map((source) => ({
                  label: ApplicationSourceMaster[source],
                  value: source,
                }))}
              />
            </Grid> */}
            {folioValidationCheck(values.applicationSource) && (
              <Grid item xs={12} sm={6} mb={2}>
                <MFTextField
                  name={`folio_no`}
                  label={`Folio Number ${
                    folioValidationCheck(values.applicationSource) ? '*' : ''
                  }`}
                  placeholder="Enter Folio Number"
                />
              </Grid>
            )}
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.corporateIdentificationNo`}
                    label="Corporate Identification number (if applicable)"
                    placeholder="Enter Corporate Identification number (if applicable)"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(investorTypeMasters).map((investor) => ({
                      key: investorTypeMasters[investor],
                      value: investor,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.taxIdNumber`}
                    label={`${
                      applicant.onboardingIdType && applicant.onboardingIdType
                        ? !isIdTypeOutOfList(applicant?.onboardingIdType || '')
                          ? ONBOARDING_ID_TYPES_MASTER[applicant?.onboardingIdType || '']
                          : applicant?.onboardingIdTypeOthers
                        : 'Id Number'
                    } *`}
                    placeholder={`Enter ${
                      applicant.onboardingIdType && applicant.onboardingIdType
                        ? !isIdTypeOutOfList(applicant?.onboardingIdType || '')
                          ? ONBOARDING_ID_TYPES_MASTER[applicant?.onboardingIdType || '']
                          : applicant?.onboardingIdTypeOthers
                        : 'Id Number'
                    }`}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <MFCheckbox
                    name={`applicants.${index}.panDeclaration`}
                    label="I, hereby declare that I do not hold a Permanent Account Number (PAN) card. I am making this declaration in accordance with the requirements of Form 49BA under Income Tax Rules for the purpose of investment in Fund.I understand that not having a PAN card necessitates the submission of Form 49BA by the Registered Intermediary to fulfill the regulatory requirements for the transaction in question. I undertake to provide all necessary details and supporting documents as required by the relevant authorities."
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                      alignItems: 'flex-start',
                      '.MuiTypography-root': {
                        fontSize: 15,
                        fontWeight: 500,
                      },
                    }}
                    checked={values.applicants[index].panDeclaration}
                  />
                </Grid>
                {!values.applicants[index].panDeclaration && (
                  <Grid item xs={12} md={6}>
                    <MFTextField
                      name={`applicants.${index}.pan`}
                      label="PAN *"
                      placeholder="Enter PAN"
                      inputProps={{ style: { textTransform: 'uppercase' } }}
                      onChange={(e) => {
                        setFieldValue(`applicants.${index}.pan`, e.target?.value?.toUpperCase());
                      }}
                    />
                  </Grid>
                )}
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income in USD"
                    items={grossAnnualMasters['foreign'].map((grossIncome) => ({
                      key: grossIncome,
                      value: grossIncome,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="Net Worth in USD"
                    placeholder="Enter Net Worth in USD"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth, 'usd')}
                      </Typography>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status *"
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                    // disabled={true}
                  />
                </Grid>
                {checkRelationshipWithPep(applicant.politicallyExposedPersonStatus || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.relationshipWithPep`}
                      label={`${getRelationshipWithPepLabel(
                        applicant.politicallyExposedPersonStatus || ''
                      )} *`}
                      placeholder={`Enter ${getRelationshipWithPepLabel(
                        applicant.politicallyExposedPersonStatus || ''
                      ).toLowerCase()}`}
                    />
                  </Grid>
                )}
              </React.Fragment>
            ))}
            <FieldValidationNote />
            <ProceedSaveLater
              goToPreviousStep={() => {
                history.push('distributor-details');
              }}
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
